import { FC, useCallback } from 'react';

import { Loader } from 'components/organization';
import ErrorDialog from 'components/organization/dialog/error-dialog';
import { useAuth } from 'contexts';
import { useBookingApi } from 'hooks/use-booking-api';
import useConfirm from 'hooks/use-confirm';
import { Role } from 'types';

import { useEditBookings } from './edit-booking.context';
import EditTrucking from './edit-trucking';
import EquipmentInformation from './equipment-information';
import GeneralInformation from './general-information';
import EditReefer from './reefer';

import '../booking-details.scss';
import './edit-booking.scss';

const EditBookingForm: FC = () => {
  const { userProfile } = useAuth();
  const { deleteBooking } = useBookingApi();
  const { ConfirmationDialog, getConfirmation } = useConfirm();
  const { booking, didSubmit, formRef, handleReset, handleSubmit } = useEditBookings();

  const handleDelete = useCallback(async () => {
    if (!booking) return;
    const confirm = await getConfirmation(
      `Delete Booking #${booking.bookingNumber}`,
      'This will remove all reserved units from booking.'
    );
    if (!confirm) return;
    await deleteBooking(booking.id);
  }, [booking, deleteBooking, getConfirmation]);

  return (
    <form className="page" id="edit-booking" onReset={handleReset} onSubmit={handleSubmit} ref={formRef}>
      <div className="page-header">
        <h1>BOOKING #{booking?.bookingNumber ?? 'N/A'}</h1>
        <div className="d-flex g-3">
          <button className="btn-outline" type="reset">
            CANCEL
          </button>
          {[Role.ADMIN, Role.BILLING_ADMIN, Role.SENIOR_BOOKING, Role.BOOKING, Role.GATE_BOOKING].includes(
            userProfile.role
          ) && (
            <button
              type="button"
              className="btn-danger"
              onClick={handleDelete}
              disabled={!booking?.bookingDetails?.every(({ delivered }) => !delivered)}
            >
              DELETE
            </button>
          )}
          <Loader loading={didSubmit}>
            <button className="btn-primary" type="submit">
              SUBMIT
            </button>
          </Loader>
        </div>
      </div>
      <div className="page-content">
        <Loader loading={booking === undefined}>
          <GeneralInformation />
          <EquipmentInformation />
          <EditReefer />
          <EditTrucking />
        </Loader>
        <ConfirmationDialog danger />
        <ErrorDialog />
      </div>
    </form>
  );
};
export default EditBookingForm;
